import { render, staticRenderFns } from "./ExcludeChildrenWarning.vue?vue&type=template&id=07f1c99e"
import script from "./ExcludeChildrenWarning.vue?vue&type=script&lang=js"
export * from "./ExcludeChildrenWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports